import { useMemo } from "react";

import { PageFormItem, InfoFormItem } from "../../components/form-item/client/components";
import { FormItem } from "../../components/form-item/framework/core/form-item.model";
import { GardenerDocument } from "../../gardener/gardener.model";

export interface CheckApplicantNameFormIds {
    SingleChoiceValidName: string;
}

export type CheckApplicantNameForm = PageFormItem<FormItem>;

type ConfirmationPage = PageFormItem<InfoFormItem>

export const useCheckApplicantNameForm = <T extends FormItem>(gardener: GardenerDocument, nextPage: T, formIds: CheckApplicantNameFormIds): CheckApplicantNameForm => {
    return useMemo((): CheckApplicantNameForm => {
        const rejectPage: ConfirmationPage = {
            type: "page",
            title: "Afvis ansøgning",
            item: {
                type: "info",
                render: "default",
                text: `
                    Ansøgningen bliver afvist.<br />
                    <br />
                    Ansøgeren informeres om, at ansøgningen blev afvist, fordi deres navn ikke var gyldigt.
                `,
            },
        };

        return {
            type: "page",
            title: "Tjek navn",
            item: {
                type: "group",
                render: "all at once",
                items: [
                    {
                        type: "info",
                        render: "default",
                        text: `
                            Du skal tjekke om havemandens ændring opfylder vores regler. 
                        `,
                    },
                    {
                        type: "notice",
                        render: "info",
                        html: `
                            <strong>Ansøgerens navn</strong><br />
                            ${gardener.name}
                        `,
                    },
                    {
                        type: "notice",
                        render: "danger",
                        html: `
                            <strong>Skal overholdes</strong><br />
                            <br />
                            <ul>
                                <li>Navnet skal være et ægte personnavn</li>
                                <li>Navnet skal stå i den rigtige rækkefølge, dvs. fornavn efterfulgt af efternavn</li>
                                <li>Navnet må ikke indeholde forkortelser, punktummer eller andre specialtegn</li>
                            </ul>
                        `,
                    },
                    {
                        id: formIds.SingleChoiceValidName,
                        type: "single-choice",
                        mode: "switch page",
                        render: "horizontal-buttons",
                        questionText: "Er ansøgerens navn gyldigt?",
                        answerTexts: ["Nej", "Ja"],
                        answerItems: [
                            rejectPage,
                            nextPage,
                        ],
                        selectedChoiceIndex: null,
                        dirty: false,
                    },
                ],
            },
        };

    }, [gardener, nextPage, formIds]);
}
